import TrackingHttp from '../../trackingHttp';

class VehicleServices {
  static async createVehicle(data) {
    return TrackingHttp.post('/vehicles', data);
  }

  static async getAllVehicles() {
    return TrackingHttp.get('/vehicles');
  }

  static async getVehicleById(id) {
    return TrackingHttp.get(`/vehicles/${id}`);
  }

  static async updateVehicleById(id, data) {
    return TrackingHttp.update(`/vehicles/${id}`, data);
  }

  static async deleteVehicleById(id) {
    return TrackingHttp.delete(`/vehicles/${id}`);
  }

  static async getVehiclesByOwnerId(ownerId) {
    return TrackingHttp.get(`/vehicles/owner/${ownerId}`);
  }
  static async getALLVehicleLocation(ownerId){
    return TrackingHttp.get(`/vehicles/locations/all/${ownerId}`);
  }
}

export default VehicleServices;
